import React, { useState, useContext, useEffect } from "react";

import { StoreContext } from "../store";

import Image from "react-bootstrap/Image";
import ImageModal from "./atoms/molecules/ImageModal";
import Filter from "./atoms/molecules/filter";
import ContactUsModal from "./atoms/molecules/ContactUsModal";
import UploadBirdModal from "./atoms/molecules/UploadBirdModal";
import DeleteConfirmation from "./atoms/molecules/DeleteConfirmation";
import { GetBirds } from "../actions";

let Catalog = (props) => {
  //const baseUrl = "http://localhost:64567";
  const { dispatch, AuthToken, Products, IsLogin, BaseURL } = useContext(
    StoreContext
  );
  const [filter, setFilter] = useState("All");
  const [showContactModal, setShowContactModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [birds, setBirds] = useState();
  useEffect(() => {
    if (Products.length == 0) GetBirds(dispatch);
  }, []);
  //const birds = Products?.filter((item) => item.Page == props.Page);

  useEffect(() => {
    let birds = Products.sort(
      (a, b) =>
        b.SortingIndex - a.SortingIndex ||
        new Date(b.Created) - new Date(a.Created)
    )?.filter((item) => item.Page == props.Page);
    setBirds(birds);
  }, [Products.length]);

  function getRootUrl() {
    var defaultPorts = { "http:": 80, "https:": 443 };

    return (
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port &&
      window.location.port != defaultPorts[window.location.protocol]
        ? ":" + window.location.port
        : "")
    );
  }

  const selectFilter = (event) => {
    setFilter(event.value);
  };

  const hideModalClick = () => {
    setShowContactModal(false);
  };

  const handleShowContact = () => {
    setShowContactModal(true);
  };

  const renderAdmin = (bird) => {
    return (
      <React.Fragment>
        {" "}
        <div className="col-item" id={'uploadModal_' + bird.GUID}>
          <div style={{ textAlign: "left" }}>
            <UploadBirdModal Text="Edit Bird" Bird={bird}></UploadBirdModal>{" "}
          </div>
        </div>
        <div className="col-item">
          <DeleteConfirmation
            show={showConfirmDeleteModal}
            closeModal={() => hideModalClick()}
            Bird={bird}
            Msg={`Are you sure you want to delete ${bird.Title} ?`}
          ></DeleteConfirmation>
        </div>
      </React.Fragment>
    );
  };
  const renderBird = (bird) => {
    const imageURL = bird.Files.filter(
      (file) =>
        (file.includes("jpg") ||
          file.includes("png") ||
          file.includes("jpeg")) &&
        !file.includes("_pedigree") &&
        !file.includes("_ped_")
    );
    return (
      <div className="catalog-container" id={'cc_' + bird.GUID}>
        <div className="description">
          <div>
          {bird.RedHeader?.length > 0?<span style={{color:'red',fontWeight:'bold', fontSize:'25px', fontStyle:'italic'}}>{bird.RedHeader}</span>:''}    
          {bird.RedHeader?.length > 0?  <br />:''}     
            <span style={{ fontWeight: "bold" }}>{bird.Title} </span>
            <br />
            {bird.Sex == 1 ? "Cock" : bird.Sex == 2 ? "Hen" : "-"}
            <br />
            {bird.Description}
            <br />
            {bird.Page == "forsale" ? bird.Price : null}
            {/* <br />
            Posted on : {new Date(bird.Created).toDateString()} */}
          </div>
        </div>
        <div className="col-container">
          <div className="col-item">
            <Image
              src={
                BaseURL +
                "/UploadedFiles/wingandaprayerloft/Catalog/" +
                imageURL
              }
              alt={bird.Title}
              style={{ width: "auto", height: "200px" }}
            />
          </div>
          <div className="col-item">
            <span>
              <ImageModal
                Text="Show Expanded View"
                ImageURL={imageURL}
                Alt={bird.Title}
                Description={bird.Description}
              ></ImageModal>
            </span>
          </div>
          {bird.Files.find(
            (file) => file.includes("pdf") || file.includes("_pedigree") || file.includes("_ped_")
          ) != undefined ? (
            <div className="col-item">
              <div>
                <a
                  href={
                    BaseURL +
                    "/UploadedFiles/wingandaprayerloft/Catalog/" +
                    bird.Files.filter(
                      (file) =>
                      file.includes("pdf") || file.includes("_pedigree") || file.includes("_ped_")
                    )
                  }
                  target="_blank"
                >
                  <span className="catalog-link">View Pedigree</span>
                </a>
              </div>
            </div>
          ) : null}
          <div className="col-item">
            <div onClick={() => setShowContactModal(true)}>
              <span className="catalog-link">Message Us About This Bird</span>
            </div>
          </div>
          {IsLogin ? renderAdmin(bird) : null}
        </div>
      </div>
    );
  };

  const renderItems = () => {
    return (
      <React.Fragment>
        {birds?.filter(
          (bird) =>
            filter == "All" ||
            filter == (bird.Sex == 2 ? "Hens" : bird.Sex == 1 ? "Cocks" : "")
        ).length > 0 ? (
          birds
            .filter(
              (bird) =>
                filter == "All" ||
                filter ==
                  (bird.Sex == 2 ? "Hens" : bird.Sex == 1 ? "Cocks" : "")
            )
            .map((filteredBird) => renderBird(filteredBird))
        ) : (
          <span style={{ color: "red", fontWeight: "bolder" }}>No Result</span>
        )}
      </React.Fragment>
    );
  };
  //test
  return (
    <React.Fragment>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div>
          <Filter FilterSelected={selectFilter} SelectedValue={filter}></Filter>
        </div>{" "}
        {IsLogin ? (
          <div style={{ textAlign: "left" }}>
            <UploadBirdModal Text="Add Bird"></UploadBirdModal>{" "}
          </div>
        ) : null}
      </div>
      <div
        style={{
          flexGrow: 2,
          display: "flex",
          justifyContent: "space-around",
          width: "100%",
          marginBottom: "10px",
          flexWrap: "wrap",
          borderTop: "1px solid gray",
          borderRadius: "10px",
        }}
      >
        {renderItems()}
      </div>
      {showContactModal ? (
        <ContactUsModal
          show={showContactModal}
          closeModal={() => hideModalClick()}          
        />
      ) : null}
    </React.Fragment>
  );
};

export default Catalog;
